import { EnergyOptionInterface } from './interfaces'

const dataLayerPush = (label: string, action: string) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'houseScanDataLayerEvent',
      houseScanType: `HouseScan ${getHost()}`,
      houseScanLabel: label,
      houseScanAction: action,
      houseScanValue: '1'
    })
  } else console.log('tag manager not initialised')
}

const getHost = () => window.location.host.replace('www.', '')

const applyInsulationMeasures = (options: EnergyOptionInterface[], constructionYear: number) => {
  let insulationMeasures: string[]   //  Glass, wall, roof, floor
  
  if (constructionYear < 1975) {
    insulationMeasures = ['Enkelglas', 'Niet geïsoleerd', 'Niet geïsoleerd', 'Niet geïsoleerd']
  } else if (constructionYear < 1983) {
    insulationMeasures = ['Dubbelglas begane grond', 'Matig geïsoleerd', 'Matig geïsoleerd', 'Niet geïsoleerd']
  } else if (constructionYear < 1992) {
    insulationMeasures = ['Dubbelglas begane grond', 'Matig geïsoleerd', 'Matig geïsoleerd', 'Matig geïsoleerd']
  } else if (constructionYear < 2000) {
    insulationMeasures = ['Dubbelglas hele huis', 'Goed geïsoleerd', 'Goed geïsoleerd', 'Goed geïsoleerd']
  } else {
    insulationMeasures = ['HR++', 'Goed geïsoleerd', 'Goed geïsoleerd', 'Goed geïsoleerd']
  }
  
  return options.map((option: EnergyOptionInterface) => {
    const activeType = option.id === 'glass' ?
      insulationMeasures[0] :
      option.id === 'wall' ?
        insulationMeasures[1] :
        option.id === 'roof' ?
          insulationMeasures[2] :
          option.id === 'ground' ?
            insulationMeasures[3] : false
    
    return {
      ...option,
      ...(activeType ? { activeType } : {}),
      active: activeType === 'Goed geïsoleerd' || activeType === 'HR++'
    }
  })
}

const remapHouseType = (houseType: string | undefined) => {
  return houseType === 'Rijwoning tussen' ? 'housetype_terraced_house' :
    houseType === 'Twee/één kapwoning' ? 'housetype_2_under_1_roof' :
      houseType === 'Twee-onder-een-kap / rijwoning hoek' ? 'housetype_corner_house' :
        houseType === 'Vrijstaande woning' ? 'housetype_detached_house' :
          houseType === 'Flat' ? 'housetype_appartment' :
            houseType === 'Niet wonen' ? 'housetype_no_home' :
              houseType
}

const extractAdditionFromHouseNumber = (houseNumber: string) => {
  for (let i = 0; i < houseNumber.length; i++) {
    if (houseNumber[i].match(/[A-Z]/i)) {
      return [houseNumber.slice(0, i), houseNumber.slice(i)]
    }
  }
  
  return [houseNumber]
}

export { dataLayerPush, getHost, applyInsulationMeasures, remapHouseType, extractAdditionFromHouseNumber }
